// | A read-only piece of data, shared between different parts of the form.
import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Partial from "../Partial/index.js";
import * as Restaumatic$dForm$dFinal from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic$dForm$dInternal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic$dForm$dQuery from "../Restaumatic.Form.Query/index.js";
import * as Restaumatic$dForm$dResult from "../Restaumatic.Form.Result/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Type$dEquality from "../Type.Equality/index.js";
const $$new = /* #__PURE__ */ Specular$dRef.new(Effect$dClass.monadEffectEffect);
const ReadOnly = x => x;
const queryReadOnly$p = dictTypeEquals => {
  const from = dictTypeEquals.proof(a => a);
  return {
    queryImpl: v => v1 => Specular$dFRP$dBase.functorDynamic.map(x => {
      const $0 = Restaumatic$dForm$dResult.functorResult.map(from)(Restaumatic$dForm$dResult.liftV(x));
      return Restaumatic$dForm$dResult.$Result($0._1, Restaumatic$dForm$dInternal.tagErrors(v1.name)($0._2), $0._3);
    })(Specular$dFRP$dBase.bindDynamic.bind(v1.value._1)(Restaumatic$dForm$dFinal.unFinalV))
  };
};
const queryImpl = /* #__PURE__ */ (() => queryReadOnly$p(Type$dEquality.refl).queryImpl)();
const initializeNoInitializerRe = () => ({makeImpl: v => Partial._crashWith("undefined")});
const initializeNoInitializerRe1 = () => ({makeImpl: v => Partial._crashWith("undefined")});
const initializeEffectInitializ = dictInitialize => ({makeImpl: Restaumatic$dForm$dInternal.makeWithEffectInitializer(dictInitialize)});
const initializeEffectInitializ1 = dictInitialize => ({makeImpl: Restaumatic$dForm$dInternal.makeWithEffectInitializer(dictInitialize)});
const dumpStateReadOnly$p = {
  dumpState: v => {
    const n = Specular$dInternal$dIncremental.constant(Foreign$dObject.empty);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  }
};
const addContextReadOnly$p = {addContext: v => v1 => () => {}};
const valueTotal = v => v1 => {
  const $0 = Restaumatic$dForm$dFinal.makeFinal(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(v));
  return v1.value._2(_old => $0);
};
const value = v => v1 => v1.value._2(_old => v);
const unsafeMakeEmptyReadOnly = opts => {
  const $0 = $$new((() => {
    const n = Specular$dInternal$dIncremental.constant(Data$dEither.$Either(
      "Left",
      Data$dMap$dInternal.$$$Map(
        "Node",
        1,
        1,
        Data$dMaybe.Nothing,
        [{fieldName: Data$dMaybe.Nothing, fieldLabel: Data$dMaybe.Nothing, message: "ReadOnly not defined", internal: true}],
        Data$dMap$dInternal.Leaf,
        Data$dMap$dInternal.Leaf
      )
    ));
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })());
  return () => {
    const value_ = $0();
    return {name: opts.name, value: value_};
  };
};
const initializeNoInitialValueR = dictTypeEquals => {
  const to = dictTypeEquals.proof(a => a);
  return dictTypeEquals1 => {
    const to1 = dictTypeEquals1.proof(a => a);
    return {
      makeImpl: v => opts => Specular$dInternal$dRIO.bindImpl(unsafeMakeEmptyReadOnly(opts))(field => Specular$dInternal$dRIO.pureImpl({
        field,
        init: v1 => initializer => valueTotal(Specular$dFRP$dBase.functorDynamic.map(to1)(to(initializer)))(field)
      }))
    };
  };
};
const initializeNoInitialValueR1 = dictTypeEquals => {
  const to = dictTypeEquals.proof(a => a);
  return {
    makeImpl: v => opts => Specular$dInternal$dRIO.bindImpl(unsafeMakeEmptyReadOnly(opts))(field => Specular$dInternal$dRIO.pureImpl({
      field,
      init: v1 => initializer => {
        const $0 = to(initializer);
        return field.value._2(_old => $0);
      }
    }))
  };
};
const makeEmptyReadOnly = {makeEmptyImpl: unsafeMakeEmptyReadOnly};
const errors = v => Specular$dFRP$dBase.functorDynamic.map((() => {
  const $0 = Data$dFunctor.arrayMap(v1 => v1.message);
  const $1 = Data$dArray.filter(x => !x.internal);
  const $2 = Data$dMap$dInternal.lookup(Data$dMaybe.ordMaybe(Data$dOrd.ordArray(Data$dOrd.ordString)))(Data$dMaybe.$Maybe("Just", v.name));
  return x => $0($1((() => {
    const $3 = $2(x);
    if ($3.tag === "Nothing") { return []; }
    if ($3.tag === "Just") { return $3._1; }
    $runtime.fail();
  })()));
})())(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.errors)(queryImpl(Restaumatic$dForm$dQuery.Strict)(v)));
export {
  ReadOnly,
  addContextReadOnly$p,
  dumpStateReadOnly$p,
  errors,
  initializeEffectInitializ,
  initializeEffectInitializ1,
  initializeNoInitialValueR,
  initializeNoInitialValueR1,
  initializeNoInitializerRe,
  initializeNoInitializerRe1,
  makeEmptyReadOnly,
  $$new as new,
  queryImpl,
  queryReadOnly$p,
  unsafeMakeEmptyReadOnly,
  value,
  valueTotal
};
